import script from "./ScreenPath.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScreenPath.vue?vue&type=script&setup=true&lang=ts"

import "./ScreenPath.vue?vue&type=style&index=0&id=6e227963&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e227963"]])

export default __exports__